module.exports = __webpack_public_path__ + "static/media/0.90893fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/head/0.png
// module id = 130
// module chunks = 0